<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <template v-if="step == 1">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col v-if="showSelect" cols="12" md="12">
              <el-radio-group
                class="mt-0 mb-4"
                label="refuseType"
                v-model="refuseType"
                :items="refuseTypes"
                required
              >
              </el-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            class="mr-2"
            tile
            @click.native="back()"
            :loading="loading"
            :title="$t('Atgal')"
          />
          <el-button
            :title="$t('Tęsti')"
            :loading="loading"
            @click.native="next()"
            color="primary"
            icon="pirmyn"
          />
        </v-row>
      </v-card-actions>
    </template>
    <template v-if="step == 2">
      <form @keydown.enter.prevent="submit()">
        <!-- data provider  -->
        <div>
          <!-- title  -->
          <h2 class="mb-1">{{ getMainTitle }}</h2>
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-PDF-viewer download :file="pdfFile" />
            </v-col>

            <v-col v-if="refuseType != 'PAPER'" class="pb-0" cols="12" md="12" >
              <el-checkbox
                class="mt-0 mb-1"
                :disabled="qualifiedSignatureRequiredDisabled"
                label="Reikalingas pasirašymas kvalifikuotu el. parašu"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Suteikiama teisė perįgalioti"
                v-model="qualifiedSignatureRequired"
                @change="qualifiedSignatureRequiredChanged"
              />
            </v-col>

            <template v-if="showAttachments">
              <v-col>
                <!-- title  -->
                <h3 class="mb-1" style="display: flex">
                  {{ $t('Dokumentai') }}
                  <el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Prokūros atsisakymas. Dokumentai" subTitle></el-tooltip>
                </h3>
                <v-card class="mb-1" outlined>
                  <!-- form  -->
                  <v-card-text class="pb-0">
                    <!-- add button  -->
                    <el-button
                      v-if="!viewMode"
                      small
                      class="mb-3"
                      color="primary"
                      icon="pridėti"
                      title="Įkelti dokumentą"
                      :loading="loading"
                      @click.native.stop="openNewDocument()"
                    />
                    <input v-if="!viewMode" id="fileUpload" type="file" @change="addFile($event)" hidden />
                    <v-data-table
                      class="mb-4 custom-table"
                      :loading="loading"
                      :headers="headers"
                      :items="formData.documents"
                      :hide-default-footer="true"
                      :header-props="{
                        sortByText: $t('Rūšiuoti pagal'),
                      }"
                    >
                      <!-- custom templates -->
                      <template #[`item.size`]="{ item }">
                      <span>{{ getItemSize(item) }}</span>
                      </template>
                      <!--  -->
                      <template #[`item.actions`]="{ item }">
                        <div class="nowrap">
                          <el-table-action
                            :item="setDocumentsItem(item)"
                            @deleteItem="deleteItem(item)"
                            @downloadItem="download(item)"
                          />
                        </div>
                      </template>
                      <!-- basic templates -->
                      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
                      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
                      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>

            <template v-if="!canStamp && !viewMode && (showCheckboxes || refuseType == 'PAPER')">
              <v-col class="py-0" cols="12" md="12">
                <el-checkbox
                  required
                  :disabled="modeReadonly"
                  notTranslated
                  :label="getConfirmDataText"
                  v-model="agreements.confirm_data"
                >
                </el-checkbox>
              </v-col>
            </template>

            <template>
               <!-- SIGNATURES -->
              <v-col class="pt-4 pb-4" cols="12" md="12" v-if="showSignatures">
                <signatures-list
                  :signatures="signatures"
                  :editMySignatures="canEditSignatures"
                  :mySignature="mySignature"
                  :editMySignaturesTitle="getSignatureEditMyTitle"
                  :listTitle="getSignatureListTitle"
                  :modalCardTitle="getSignaturesModalTitle"
                  :dataType="getDataType"
                  emitOnSave
                  @saveEvent="saveSignatures"
                  :loadingList="pageloading"
                  :hide-info="hideSignaturesInfoText"
                  :inJournalType="getJournalType"
                ></signatures-list>
              </v-col>

              <v-col class="pt-1 pb-2" cols="12" md="12">
                <v-card  outlined>
                  <v-card-text>
                    <v-row>
                      <v-col class="pb-2" cols="12" >
                        <span><strong>{{ `${$t('Būsena')}: ` }}</strong><span :class="getStatusClass">{{ getStatus }}</span></span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>
          </v-row>
        </div>
        <!-- actions  -->
        <v-card-actions v-if="!showSigningComponent">
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-2"
              tile
              @click.native="back()"
              :loading="loading"
              title="Atgal"
            />
             <el-button
              v-if="canCancelSigning"
              class="mr-1"
              title="Atšaukti pasirašymą"
              :loading="loading"
              @click.native="beforeCancel()"
              color="secondary"
              icon="atšaukti"
            />
            <template v-if="showTooltipBtn">
              <v-tooltip v-if="canConfirmDocument" top max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    class="v-btn-primary"
                    :loading="loading"
                    @click.native="confirm()"
                    >
                    {{ $t('Perduoti atstovų patikrinimui') }}
                  </v-btn>
                </template>
                <div class="tooltip-text">{{ $t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.') }}</div>
              </v-tooltip>
            </template>
            <template v-else>
              <el-button
                v-if="canConfirmDocument"
                :title="getBtnText"
                :loading="loading"
                @click.native="confirm()"
                color="primary"
                icon="pirmyn"
              />
            </template>
            <el-button
              class="mr-1"
              v-if="canRefuseToSign"
              title="Atsisakyti pasirašyti"
              :loading="loading"
              @click.native="beforeRefuse()"
              color="secondary"
              icon="atšaukti"
            />
            <template v-if="qualifiedSignatureRequired">
              <template v-if="canInitQualifiedSignature">
                <el-button
                  class="mr-1"
                  title="Pasirašyti el. parašu"
                  :loading="loading"
                  @click.native="saveData()"
                  color="primary"
                  icon="pirmyn"
                />
              </template>
              <template v-if="canStamp">
                <el-button
                  class="mr-1"
                  title="Tęsti be spaudo"
                  :loading="loading"
                  @click.native="cancelStampRequired()"
                  color="secondary"
                />
                <el-button
                  class="mr-1"
                  title="Tvirtinti el. spaudu"
                  :loading="loading"
                  @click.native="initStamping()"
                  color="primary"
                  icon="pirmyn"
                />
              </template>
            </template>
            <template v-else>
              <el-button
                v-if="canSign"
                :title="$t('Atšaukti prokūrą')"
                :loading="loading"
                @click.native="sign()"
                color="primary"
                icon="pirmyn"
              />
            </template>
          </v-row>
        </v-card-actions>
      </form>
    </template>

    <modal-confirm
      :title="getBtnText"
      :code="getModalConfirmCode"
      v-model="showConfirmModal"
      :trueText="getConfirmTrueText"
      :loading="loading"
      @confirmData="saveData"
    />
    <modal-delete
      title="Šalinti dokumentą"
      :text="deleteText"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-confirm
      :title="getBtnSignText"
      :text="getSignText"
      :trueText="getSignTrueText"
      v-model="showConfirmSignModal"
      :loading="loading"
      @confirmData="signData"
    />
    <modal-custom
      :title="$t('Pasirašymo atšaukimas')"
      :text="$t('Ar tikrai norite atšaukti pasirašymą?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showCancelModal"
      @confirmData="confirmCancel"
    />
    <modal-custom
      :title="$t('Atsisakymas pasirašyti')"
      :text="$t('Ar tikrai norite atsisakyti pasirašyti?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showRefuseModal"
      @confirmData="confirmRefuse"
    />
    <modal-custom
      :title="$t('Perduoti atstovų patikrinimui')"
      :text="$t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.')"
      trueText="Perduoti patikrinimui"
      falseText="Ne"
      :loading="loading"
      v-model="showApproveRepresentersModal"
      @confirmData="saveData"
    />

    <modal-sign
      :openSign="showSigningComponent"
      :objectId="inJournalId"
      objectType="in_journal"
      @stampDecision="stampDecision"
      @cancelSigning="cancelSigning"
      @signed="signingSuccessfull"
    />
  </v-container>
</template>

<script>
import Enums from '@/enums'
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import errorNotifications from '@/mixins/errorNotifications'
import ModalConfirm from '@/components/modals/ModalConfirm'
import ModalDelete from '@/components/modals/ModalDelete'
import SignaturesList from '@/components/signatures/SignaturesList'
import InJournalStatuses from '@/components/constants/inJournalStatus'
import ModalCustom from '@/components/modals/ModalCustom'
import math from '@/mixins/math'
import SavitarnaMenu from '@/components/constants/savitarnaMenu.js'
import { getFileSetting } from '@/services/classifierService.js'
import ModalSign from '@/components/modals/ModalSign.vue'

export default {
  name: 'ProcurationRefuseOrCancellation',
  components: { ModalConfirm, ModalDelete, SignaturesList, ModalCustom, ModalSign},
  mixins: [userRole, unsavedData, errorNotifications, math],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showApproveRepresentersModal: false,
      showCancelModal: false,
      showRefuseModal: false,
      pageloading: false,
      showAddPerson: false,
      loading: false,
      mandateKind: null,
      formData: {},
      agreements: {
        confirm: false,
        read_understood: false,
        confirm_data: false,
      },
      showConfirmModal: false,
      pdfFile: {},
      documentsToDelete: [],
      showDelete: false,
      deleteText: 'Ar tikrai norite pašalinti dokumentą?',
      modalDeleteItem: null,
      refuseType: 'PAPER',
      step: 2,
      signatures: [],
      showCheckboxes: true,
      mySignature: {},
      canEditSignatures: false,
      showConfirmSignModal: false,
      showSigningComponent: false,
      qualifiedSignatureRequired: false,
      inJournalId: null,
      stampRequired: false,
    }
  },
  computed: {
    canConfirmDocument() {
      if (this.canInitQualifiedSignature) {
        return false;
      }

      if(this.showTooltipBtn && this.signatures.length == 0){
        return false
      }

      return !this.viewMode && ((this.refuseType == 'PAPER' && this.formData?.documents && this.formData.documents.length) || this.refuseType != 'PAPER')
    },
    canInitQualifiedSignature() {
      if (!this.getTypeTerminate) {
        return this.qualifiedSignatureRequired && this.formData.status != InJournalStatuses.ATSAUKTAS && this.formData.status != InJournalStatuses.IVYKDYTAS;
      } else {
        return this.qualifiedSignatureRequired
          && (
            (this.formData.status == InJournalStatuses.LAUKIA_PASIRASYMO || this.formData.status == InJournalStatuses.ATSTOVAI_PATVIRTINTI)
            && this.formData.buttons?.sign
          )
      }
    },
    canStamp() {
      return this.formData.buttons?.stamp;
    },
    qualifiedSignatureRequiredDisabled() {
      return this.formData.status != InJournalStatuses.RENGIAMAS
        && this.formData.status != InJournalStatuses.LAUKIA_PATVIRTINIMO
        && this.formData.status != InJournalStatuses.ATSTOVAI_PATVIRTINTI
    },
    showSignatures() {
      return this.formData.receive_mode != 307
    },
    getDataType(){
      // Dėl vaizdavimo gimimo datos visose prokūrose
      return 'jur_representer_against_parent'
      // return this.refuseType == 'PAPER' ? 'jur_representer' : 'jur_representer_against_parent'
    },
    canRefuseToSign(){
      return this.formData.buttons?.refuseToSign
    },
    canCancelSigning(){
      return this.formData.buttons?.cancelSigning
    },
    canSign() {
      return this.formData.buttons?.sign
    },
    getStatus(){
      let statuses = this.$i18n.locale === 'lt' ? Enums.journalType.lt : Enums.journalType.en
      return statuses[this.formData.status]
    },
    getStatusClass(){
      return this.formData.status == InJournalStatuses.ATSAUKTAS ? 'text-red' : ''
    },
    getSignaturesModalTitle() {
      return this.refuseType == 'PAPER' ? this.$t('Atstovai ir kontaktai') : this.$t('Pasirašančiųjų eilė ir kontaktai')
    },
    getSignatureEditMyTitle() {
      return this.$t('Pridėti / Redaguoti prokūrą išduodančio valdymo organo narius ir kontaktus')
    },
    getSignatureListTitle() {
      return this.refuseType == 'PAPER' ? (this.getTypeTerminate ? this.$t('Atstovai') : this.$t('Prokuristas')) : this.$t('Pasirašantys asmenys')
    },
    getSignText() {
      return this.notificationText(this.getTypeTerminate ? '000072' : '000073')
    },
    getBtnSignText() {
      return this.getTypeTerminate
        ? this.$t('Atšaukti prokūrą')
        : this.$t('Atsisakyti prokūros')
    },
    getSignTrueText() {
      return this.refuseType == 'PAPER' ? (this.getTypeTerminate ? this.$t('Atšaukti') : this.$t('Atsisakyti')) : this.$t('Pasirašyti')
    },
    showSelect() {
      return this.step == 1
    },
    showForm() {
      return this.step == 2
    },
    refuseTypes() {
      return [
        {
          label: this.getTypeTerminate ? this.$t('Prokūros atšaukimas elektroniniu būdu') : this.$t('Prokūros atsisakymas elektroniniu būdu'),
          value: 'ELECTRONIC',
        },
        {
          label: this.getTypeTerminate ? this.$t('Prokūros atšaukimas pateikiant dokumentus') : this.$t('Prokūros atsisakymas pateikiant dokumentus'),
          value: 'PAPER',
        },
      ]
    },
    showAttachments() {
      return this.refuseType == 'PAPER' && this.formData.receive_mode != 307
    },
    hideSignaturesInfoText() {
      return this.refuseType == 'PAPER'
    },
    viewMode() {
      return this.$route.params.view || false
    },
    getConfirmText() {
      return this.notificationText(this.getTypeTerminate ? '000072' : '000073')
    },
    getConfirmTrueText() {
      return this.refuseType == 'PAPER' ? (this.getTypeTerminate ? this.$t('Atšaukti') : this.$t('Atsisakyti')) : this.$t('Pasirašyti')
    },
    getReadUnderstoodText() {
      return this.notificationText(this.getTypeTerminate ? '000074' : '000075')
    },
    getConfirmDataText() {
      return this.notificationText(this.getTypeTerminate ? '000076' : '000077')
    },
    getModalConfirmCode() {
      return this.getTypeTerminate ? '000072' : '000073'
    },
    getValidateErrorCode() {
      return this.getTypeTerminate ? '000078' : '000079'
    },
    showTooltipBtn(){
      return this.getTypeTerminate && this.refuseType != 'PAPER'
    },
    getBtnText() {
      return this.getTypeTerminate ? (this.refuseType == 'PAPER'  ?  this.$t('Atšaukti prokūrą') : this.$t('Perduoti atstovų patikrinimui'))
        : this.$t('Atsisakyti prokūros')
    },
    getId() {
      return this.$route.params.id || null
    },
    getTypeTerminate() {
      return this.$route.name === 'savProcurationTerminate'
    },
    getJournalType() {
      return this.getTypeTerminate ? '422' : '423'
    },
    modeReadonly() {
      return false
    },
    getMainTitle() {
      return this.getTypeTerminate
        ? this.$t('Prokūros atšaukimas')
        : this.$t('Prokūros atsisakymas')
    },

    // Documents table
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Dokumento pavadinimas'),
          align: 'start',
          value: 'original_filename',
        },
        {
          text: this.$t('Dydis'),
          align: 'start',
          value: 'size',
        },
        {
          text: this.$t('Įkėlimo data'),
          align: 'start',
          value: 'created_at',
        },
      ]
    },
  },
  created() {
    this.getData()
    if (!this.viewMode) {
      this.getSignatures()
    }
  },
  mounted() {
    this.fileTypes = sessionStorage.getItem('file_types')
    this.maxSize = sessionStorage.getItem('max_file_size')
    if (!this.fileTypes){
      getFileSetting();
    }
  },
  methods: {
    stampDecision(decision) {
      this.stampRequired = decision
    },
    initElSigning() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.showSigningComponent = true
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },

    initStamping() {
      this.showSigningComponent = true
    },

    cancelStampRequired() {
      this.pageloading = true
      this.$axios
        .post(`/gosign/cancel-stamping/${this.inJournalId}`)
        .then((res) => {
          if (res.data.toBasket) {
            window.location.href =  process.env.VUE_APP_BASKET_URL
          } else {
            let link = SavitarnaMenu.MANO_DOKUMENTAI
            window.location.href = link
            this.showSigningComponent = false
          }
        })
        .catch((err) => {
          if(err.response.status === 404){
            return this.$router.push({ name: 'sav404' })
          } else {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },

    cancelSigning() {
      this.showSigningComponent = false
      if (!this.viewMode) {
        if (this.getTypeTerminate) {
          this.$router.push({
              name: 'savProcurationTerminate',
              params: {
                id: this.inJournalId,
                view: 'view'
              },
            })
          // location.reload()
        } else {
          this.$router.push({
              name: 'savProcurationRefuse',
              params: {
                id: this.inJournalId,
                view: 'view'
              },
            })
          // location.reload()
        }
      }
    },

    signingSuccessfull() {
      if (this.getTypeTerminate && this.stampRequired) {
        this.$router.push({
            name: 'savProcurationTerminate',
            params: {
              id: this.inJournalId,
              view: 'view'
            },
          })
        // location.reload()
      } else {
        let link = SavitarnaMenu.MANO_DOKUMENTAI
        window.location.href = link
      }

      this.showSigningComponent = false
    },

    qualifiedSignatureRequiredChanged() {
      if (this.formData.status == InJournalStatuses.ATSTOVAI_PATVIRTINTI) {
        this.loading = true;
        this.$axios.post(`in-journals/${this.inJournalId}/singnature-required-changed`, {signature_required: this.qualifiedSignatureRequired})
          .finally(() => {
            this.loading = false;
          })
      }
    },

    beforeCancel(){
      this.showCancelModal = true
    },
    beforeRefuse(){
      this.showRefuseModal = true
    },
    confirmRefuse() {
      this.refuse()
    },
    beforeApproveRepresenters() {
      this.showApproveRepresentersModal = true;
    },
    confirmCancel(){
      this.cancel()
    },
    cancel(){
      this.loading = true
      this.pageloading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.inJournalId}/cancel`
      this.$axios.post(url, formData)
      .then((res) => {
        let link = SavitarnaMenu.MANO_DOKUMENTAI
        window.location.href = link
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showCancelModal = false
        this.loading = false
        this.pageloading = false
      })
    },
    refuse(){
      this.loading = true
      this.pageloading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.getId}/refuse`
      this.$axios.post(url, formData)
      .then((res) => {
        this.$root.$emit('DATA_OK_STEP')
        // then
        this.initialForm()
        this.formData = {};
        this.pdfFile = {};
        return this.getData()
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showRefuseModal = false
        this.loading = false
        this.pageloading = false
      })
    },
    signData() {
      this.loading = true
      this.pageloading = true
      this.$axios.post(`in-journals/${this.formData.id}/sign`)
        .then(res => {
            let link = SavitarnaMenu.MANO_DOKUMENTAI
            window.location.href = link
        })
        .catch(err => {
          this.$root.$emit('DATA_ERROR_CODE', '000088')
          this.pageloading = false
          this.loading = false
        })
    },
    getSignatures() {
      this.$axios
        .get(`mandates/${this.getId}/mySignatures/${this.getJournalType}`)
        .then((res) => {
          this.signatures = res.data.signatures
          this.formData.status = res.data.status
          this.canEditSignatures = res.data.canEditSignatures
          this.mySignature = res.data.mySignature
          this.showCheckboxes = res.data.showCheckboxes == true
        })
        .catch((err) => {
          if(err.response.status === 404){return}
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveSignatures(signatures) {
      if (signatures.length == 0) {
        // this.signatures = [this.mySignature]
      } else {
        this.signatures = signatures
      }
    },
    sign() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.showConfirmSignModal = true
        } else {
          this.$root.$emit('DATA_ERROR_CODE', this.getValidateErrorCode)
        }
      })
    },
    move(from, to){
      this.signatures.splice(to, 0, this.signatures.splice(from, 1)[0]);
    },
    back() {
      if (this.viewMode || this.step == 1) {
        this.$router.go(-1)
      } else {
        // this.signatures = [this.mySignature];
        this.step = 1
      }
    },
    next() {
      this.step = 2
    },
    confirm() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.showCheckboxes || this.refuseType == 'PAPER') {
            this.showConfirmModal = true
          } else {
            this.showApproveRepresentersModal = true
          }
        } else {
          this.$root.$emit('DATA_ERROR_CODE', this.getValidateErrorCode)
        }
      })
    },
    getPdfFile() {
      this.pageloading = true
      // 408 - Panaikinimas, 409 - atsisakymas
      let url = "";
      if(this.viewMode){
        url = `in-journals/${this.getId}/preview`
      }else {
         url = `in-journals/${this.getId}/pregenerate/${this.getJournalType}`
      }
      this.$axios
        .get(url)
        .then((res) => {
          this.pdfFile = res.data
          this.pdfFile.original_filename = 'Peržiūra.pdf'
        })
        .catch((err) => {
          if(err.response.status === 404){
            return this.$router.push({ name: 'sav404' })
          } else {
              this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    getData() {
      this.getPdfFile()
      if (this.viewMode) {
        this.pageloading = true
        let id = this.inJournalId || this.getId;
        this.$axios
          .get(`in-journals/${id}`)
          .then((res) => {
            this.inJournalId = res.data.inJournal.id
            this.formData = res.data.inJournal
            this.mandateKind = res.data.inJournal.mandate.kind
            this.refuseType = res.data.inJournal.documents.length ? 'PAPER' : 'ELECTRONIC'
            this.step = 2
            this.signatures = res.data.inJournal.signatures
            this.formData.buttons = res.data.inJournal.agreements.buttons
            this.qualifiedSignatureRequired = res.data.inJournal.signature_required
          })
          .catch((err) => {
            if(err.response.status === 404){return}
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {
            this.pageloading = false
          })
      } else {
        this.pageloading = true
        this.refuseType = 'ELECTRONIC'
        this.step = 1
        this.$axios
          .get(`mandates/${this.getId}`)
          .then((res) => {
            this.mandateKind = res.data.mandate.mandate_kind
          })
          .catch((err) => {
            if(err.response.status === 404){return}
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {
            this.pageloading = false
          })
      }
    },

    saveData() {
      this.loading = true
      let formData = new FormData()
      let totalFileSize = 0
      let emitError;
      let fileTypes = sessionStorage.getItem('file_types')
      if (this.formData?.documents?.length > 0) {
        Object.keys(this.formData.documents).map((value, key) => {
          if (this.formData.documents[key].file !== undefined) {
            totalFileSize += this.formData.documents[key].file.size
            let filename = this.formData.documents[key].file.name
            let extension = filename.substr(filename.lastIndexOf('.') + 1)

            if (fileTypes.includes(extension.toLowerCase())) {
              formData.append(
                `documents[${key}]`,
                this.formData.documents[key].file
              )
            } else {
              emitError = 'FILE_EXTENSION_NOT_ALLOWED';
            }
          }
        })
      }

      if (totalFileSize > sessionStorage.getItem('max_file_size')) {
        emitError = 'FILE_TOO_LARGE'
      }


      if (emitError === undefined) {
        this.pageloading = true
        // let formData = this.agreements
        formData.append('mandate_id', this.getId)
        formData.append('journal_type', this.getJournalType)
        // formData.append('confirm', this.agreements.confirm ? 1 : 0)
        // formData.append('read_understood', this.agreements.read_understood ? 1 : 0)
        formData.append('confirm_data', this.agreements.confirm_data ? 1 : 0)
        formData.append('refuse_type', this.refuseType)
        formData.append('signature_required', this.qualifiedSignatureRequired ? 1 : 0)
        formData.append('signatures', [])
        this.signatures.map((signature, index) => {
          formData.append('signatures[' + index + '][amn_id]', signature.amn_id)
          formData.append('signatures[' + index + '][order_no]', index+1)
          formData.append('signatures[' + index + '][email_enabled]', signature.email_enabled)
          formData.append('signatures[' + index + '][email_address]', signature.email_address)
          formData.append('signatures[' + index + '][sms_enabled]', signature.sms_enabled)
          formData.append('signatures[' + index + '][phone_number_prepend]', signature.phone_number_prepend)
          formData.append('signatures[' + index + '][phone_number]', signature.phone_number)
        })

        if (this.inJournalId) {
          formData.append('in_journal_id', this.inJournalId);
        }

        let url = `in-journals/action`
        this.$axios
          .post(url, formData)
          .then((res) => {
            this.$set(this.formData, 'journal', res.data.data)
            this.$set(this.formData, 'status', res.data.data.status)
            this.$set(this.formData, 'buttons', res.data.data.agreements.buttons)

            this.inJournalId = res.data.data.id
            if (this.qualifiedSignatureRequired && res.data.data.status != InJournalStatuses.ATSTOVU_TIKRINIMAS) {
              this.initElSigning()
            } else {
              if (res.data.data.status == InJournalStatuses.LAUKIA_PASIRASYMO) {
                this.signData()
              } else {
                this.$root.$emit('DATA_OK', '000114')
                // redirect
                this.$router.push({
                  name: 'savProcurations',
                })
              }
            }

          })
          .catch((err) => {
            if(err.response.data.errors.signatures[1] || err.response.data.errors[0]){
              this.$root.$emit('DATA_ERROR_TEXT', err.response.data.errors.signatures[1] || err.response.data.errors[0])
            } else {
              this.$root.$emit('DATA_ERROR_CODE', '000094')
            }
          })
          .finally(() => {
            this.loading = false
            this.pageloading = false
          })
      } else {
        this.$root.$emit(emitError)
        this.loading = false
      }
    },
    // Documents table
    openNewDocument() {
      document.getElementById('fileUpload').click()
    },
    addFile(e) {
      let file = e.target.files[0]
      let obj = {
        canDelete: true,
        file: file,
        original_filename: file.name,
        size: this.bytesToSize(file.size),
        create_id: `${file.name}-${Date.now()}`,
      }

      if (
        typeof this.formData.documents === 'undefined' ||
        !Array.isArray(this.formData.documents)
      ) {
        this.$set(this.formData, 'documents', [])
      }
      this.formData.documents.push(obj)
      document.getElementById('fileUpload').value = ""
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteItem(item) {
      this.deleteText = this.$t(`Ar tikrai norite pašalinti dokumentą`) + ' ' + item.original_filename + `?`
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.showDelete = false
      if(item.id){
        this.documentsToDelete.push(item.id)
        this.formData.documentsToDelete = this.documentsToDelete
      }
      // uploaded
      if(item.id){
        const index = this.formData.documents.findIndex(
        (document) => document.id === item.id
        )
        if (index > -1) {
          this.formData.documents.splice(index, 1)
        }
      } else {
        const subIndex = this.formData.documents.findIndex(
          (document) => document.create_id === item.create_id
        )
        if (subIndex > -1) {
          this.formData.documents.splice(subIndex, 1)
        }
      }
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    setDocumentsItem(item){
      if(item.id){
        item.canDownload = true
        item.canDelete = true
      }
      return item
    },
    getItemSize(item){
      if(item.id){
        return this.bytesToSize(item.size)
      } else {
        return item.size
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
